@file:OptIn(InternalResourceApi::class)

package wordvoyage.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/wordvoyage.shared.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_300_355_446)
internal val Res.drawable.ic_arrow_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_back.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_330_459_498)
internal val Res.drawable.ic_book: DrawableResource by lazy {
      DrawableResource("drawable:ic_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_book.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_123_152_464)
internal val Res.drawable.ic_chevron_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_chevron_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chevron_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_820_643_200)
internal val Res.drawable.ic_delete: DrawableResource by lazy {
      DrawableResource("drawable:ic_delete", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_delete.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(481_273_487)
internal val Res.drawable.ic_delete_account: DrawableResource by lazy {
      DrawableResource("drawable:ic_delete_account", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_delete_account.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-346_498_701)
internal val Res.drawable.ic_examples: DrawableResource by lazy {
      DrawableResource("drawable:ic_examples", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_examples.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_914_404_216)
internal val Res.drawable.ic_history: DrawableResource by lazy {
      DrawableResource("drawable:ic_history", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_history.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(645_387_613)
internal val Res.drawable.ic_link: DrawableResource by lazy {
      DrawableResource("drawable:ic_link", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_link.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_036_024_158)
internal val Res.drawable.ic_logout: DrawableResource by lazy {
      DrawableResource("drawable:ic_logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logout.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_622_531_132)
internal val Res.drawable.ic_more_vert: DrawableResource by lazy {
      DrawableResource("drawable:ic_more_vert", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_more_vert.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(21_991_972)
internal val Res.drawable.ic_privacy: DrawableResource by lazy {
      DrawableResource("drawable:ic_privacy", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_privacy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_156_112_438)
internal val Res.drawable.ic_refresh: DrawableResource by lazy {
      DrawableResource("drawable:ic_refresh", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_refresh.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-751_886_607)
internal val Res.drawable.ic_sparkle: DrawableResource by lazy {
      DrawableResource("drawable:ic_sparkle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sparkle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_428_178_149)
internal val Res.drawable.ic_target: DrawableResource by lazy {
      DrawableResource("drawable:ic_target", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_target.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_723_824_602)
internal val Res.drawable.ic_usage: DrawableResource by lazy {
      DrawableResource("drawable:ic_usage", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_usage.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_723_380_458)
internal val Res.drawable.ic_volume_up: DrawableResource by lazy {
      DrawableResource("drawable:ic_volume_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_volume_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_180_830_028)
internal val Res.drawable.ic_warning: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_warning.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_arrow_back", Res.drawable.ic_arrow_back)
  map.put("ic_book", Res.drawable.ic_book)
  map.put("ic_chevron_right", Res.drawable.ic_chevron_right)
  map.put("ic_delete", Res.drawable.ic_delete)
  map.put("ic_delete_account", Res.drawable.ic_delete_account)
  map.put("ic_examples", Res.drawable.ic_examples)
  map.put("ic_history", Res.drawable.ic_history)
  map.put("ic_link", Res.drawable.ic_link)
  map.put("ic_logout", Res.drawable.ic_logout)
  map.put("ic_more_vert", Res.drawable.ic_more_vert)
  map.put("ic_privacy", Res.drawable.ic_privacy)
  map.put("ic_refresh", Res.drawable.ic_refresh)
  map.put("ic_sparkle", Res.drawable.ic_sparkle)
  map.put("ic_target", Res.drawable.ic_target)
  map.put("ic_usage", Res.drawable.ic_usage)
  map.put("ic_volume_up", Res.drawable.ic_volume_up)
  map.put("ic_warning", Res.drawable.ic_warning)
}
